import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyDe = () => {
    return <PrivacyPolicy languageCode="de" />
}

export default PrivacyPolicyDe
